export {
  default,
  type TableData,
  type TableDataValue,
} from "./ReadingSkillsDataTable";
